import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useState, useEffect } from 'react';
import apiClient from '../api/client';
const FeatureSwitchContext = createContext({
    featureSwitches: {},
    loading: true,
});
export const useFeatureSwitch = () => useContext(FeatureSwitchContext);
export const FeatureSwitchProvider = ({ children }) => {
    const [featureSwitches, setFeatureSwitches] = useState({});
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const fetchFeatureSwitches = async () => {
            try {
                const { data } = await apiClient.get('/feature-switches');
                setFeatureSwitches(data);
            }
            catch (error) {
                console.error('Failed to fetch feature switches', error);
            }
            finally {
                setLoading(false);
            }
        };
        fetchFeatureSwitches();
    }, []);
    return (_jsx(FeatureSwitchContext.Provider, { value: { featureSwitches, loading }, children: children }));
};
